import type { Persistor } from 'redux-persist'

import { AppDispatch, purgePersistedState, resetAllApiState, schoolSessionReset } from '~/redux/store'

/**
 * Leaves nothing of the previous person on a shared school device: memory, API caches and storage.
 *
 * ⚠ The order matters. The reset first, because purging storage does not clear memory and the next
 * dispatch would write the old state straight back. Then flush: redux-persist queues its write for a
 * later tick, so a snapshot queued by the reset would otherwise land after the purge and put the key back.
 */
export const resetSchoolDevice = async (dispatch: AppDispatch, persistor?: Persistor): Promise<void> => {
  dispatch(schoolSessionReset())
  resetAllApiState(dispatch)
  await persistor?.flush()
  purgePersistedState()
}
